import { gql } from '@apollo/client';
import type IEmployeeTalkTemplate from '@sharedInterfaces/IEmployeeTalkTemplate';
import type { IEmployeeTalkTemplatePage } from '@sharedInterfaces/IEmployeeTalkTemplate';

import GraphQL from '../graphQL';

const CREATE_EMPLOYEE_TALK_TEMPLATE = gql`
  mutation CreateEmployeeTalkTemplate(
    $title: String!,
    $description: String!,
    $pages: [EmployeeTalkTemplatePageInput!]!,
    $isActive: Boolean
  ) {
    createEmployeeTalkTemplate(
      title: $title,
      description: $description,
      pages: $pages,
      isActive: $isActive
    ) {
      id
      title
      description
      templateVersion
      pages {
        id
        title
        order
        sections {
          id
          title
          order
          columns {
            id
            components {
              id
              type
              label
              description
              required
              order
              properties
            }
          }
        }
      }
      isActive
      createdAt
      changedAt
    }
  }
`;

export async function createEmployeeTalkTemplate(
    title: string,
    description: string,
    pages: IEmployeeTalkTemplatePage[],
    isActive: boolean = true,
): Promise<IEmployeeTalkTemplate> {
    return GraphQL.mutate<IEmployeeTalkTemplate>(CREATE_EMPLOYEE_TALK_TEMPLATE, {
        title,
        description,
        pages,
        isActive,
    }).then((t) => {
        switch (typeof t.id) {
            case 'string':
                t.id = Number.parseInt(t.id);
                break;
        }
        return t;
    });
}
